export const HOME = {
  emergentLink: "home-emergent-link",
  heroShopBtn: "home-hero-shop-btn",
  heroStoryBtn: "home-hero-story-btn",
  shopFashionBtn: "home-shop-fashion-btn",
  shopTrainingBtn: "home-shop-training-btn",
  shopOutdoorsBtn: "home-shop-outdoors-btn",
  readStoryBtn: "home-read-story-btn",
  findSupportBtn: "home-find-support-btn",
  newsletterFirstName: "home-newsletter-first-name",
  newsletterEmail: "home-newsletter-email",
  newsletterConsent: "home-newsletter-consent",
  newsletterSubmit: "home-newsletter-submit",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  store: "nav-store",
  support: "nav-support",
  basket: "nav-basket",
  search: "nav-search",
  account: "nav-account",
  mobileToggle: "nav-mobile-toggle",
  announcementBar: "nav-announcement-bar",
};

export const STORE = {
  filterCategory: "store-filter-category",
  filterLifestyle: "store-filter-lifestyle",
  filterCollection: "store-filter-collection",
  filterGender: "store-filter-gender",
  sortBy: "store-sort-by",
  productCard: "store-product-card",
  productLink: "store-product-link",
  clearFilters: "store-clear-filters",
  resultsCount: "store-results-count",
};

export const PRODUCT = {
  title: "product-title",
  price: "product-price",
  sizeSelect: "product-size-select",
  colorSelect: "product-color-select",
  qtyMinus: "product-qty-minus",
  qtyPlus: "product-qty-plus",
  addToBasket: "product-add-to-basket",
  thumbnail: "product-thumbnail",
  storyToggle: "product-story-toggle",
  detailsToggle: "product-details-toggle",
  relatedCard: "product-related-card",
};

export const BASKET = {
  item: "basket-item",
  removeItem: "basket-remove-item",
  qtyMinus: "basket-qty-minus",
  qtyPlus: "basket-qty-plus",
  total: "basket-total",
  checkoutBtn: "basket-checkout-btn",
  continueBtn: "basket-continue-btn",
  emptyState: "basket-empty-state",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const ADMIN = {
  passwordInput: "admin-password-input",
  loginBtn: "admin-login-btn",
  logoutBtn: "admin-logout-btn",
  addProductBtn: "admin-add-product-btn",
  productRow: "admin-product-row",
  editBtn: "admin-edit-btn",
  deleteBtn: "admin-delete-btn",
  saveBtn: "admin-save-btn",
  cancelBtn: "admin-cancel-btn",
  fieldSlug: "admin-field-slug",
  fieldName: "admin-field-name",
  fieldPrice: "admin-field-price",
  fieldCategory: "admin-field-category",
  fieldDescription: "admin-field-description",
  fieldStory: "admin-field-story",
  fieldImages: "admin-field-images",
  fieldColors: "admin-field-colors",
  fieldSizes: "admin-field-sizes",
  fieldCollection: "admin-field-collection",
};
